<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<!-- Mesmo cabeçalho das demais listagens (Empresas): título e contador à esquerda, ação à direita, com o
     recuo lateral da página para o botão não passar da borda. -->
<header class="partner-header">
  <div class="partner-header__title">
    <h1>Parceiros</h1>
    @if (loaded()) {
      <p class="partner-header__count">
        {{ total() }} {{ total() === 1 ? 'parceiro cadastrado' : 'parceiros cadastrados' }}
      </p>
    } @else {
      <span class="partner-header__count-skeleton" aria-hidden="true"></span>
    }
  </div>

  <div class="partner-header__actions" *appHasPermission="permissions.CREATE">
    <app-button label="Cadastrar parceiro" icon="pi pi-plus" (sendButtonClick)="novoParceiro()" />
  </div>
</header>

<!-- Sem o app-loading no lugar da tabela: o próprio app-table mostra o esqueleto na primeira carga e, nas
     seguintes (busca, página), fica montado, sem perder o foco da busca. -->
<!-- `getOptionsFunction` tem binding CONDICIONAL, e não é a função que devolve lista
       vazia: o `app-table` decide se renderiza a coluna de ações olhando se a função está
       bindada, nunca o que ela devolve. Com a função sempre presente, quem tem
       `PARTNER_LIST` sem `PARTNER_UPDATE` ganharia um "⋯" abrindo um menu vazio. -->
<app-table
  #table
  [items]="partners()"
  [columnDefinitions]="columnDefinitions"
  [totalRecords]="total()"
  [rows]="pageSize()"
  [loading]="loading()"
  [showSearch]="true"
  [searchPlaceholder]="'Buscar por nome ou e-mail'"
  [getOptionsFunction]="podeEditar() ? acoesDaLinha.bind(this) : undefined"
  (sendTablePagination)="onPaginacao($event)"
  (sendTableFilter)="onBusca($event)">
  <!-- A situação é a informação que se procura de relance na listagem, e um "true/false"
         cru não comunica nada. O inativo é quem precisa saltar, então é ele que ganha cor. -->
  <!-- Indicado por (card 3683): parceiro dono do link e, embaixo, o usuário dele que gerou o link. -->
  <ng-template appNamedTemplate="referredByPartnerName" let-item>
    @if (item.referredByPartnerName) {
      <div class="partner-referred-by" [title]="item.referredByUserName ? 'Link de ' + item.referredByUserName : ''">
        <span class="partner-referred-by__partner">{{ item.referredByPartnerName }}</span>
        @if (item.referredByUserName) {
          <span class="partner-referred-by__user">{{ item.referredByUserName }}</span>
        }
      </div>
    } @else {
      <span class="partner-referred-by__empty">—</span>
    }
  </ng-template>
  <ng-template appNamedTemplate="active" let-item>
    <span class="partner-status" [class.partner-status--inactive]="!item.active">
      {{ item.active ? 'Ativo' : 'Inativo' }}
    </span>
  </ng-template>
</app-table>
